export const Name = 'Whatfix Marketplace'
export const SUCCESS = 'SUCCESS'
export const FAILURE = 'FAILURE'
export const GA_MEASUREMENT_ID = 'G-BPG5GQSBQ3'
export const USECASE = 'Use Case'
export const APPLICATION = 'Application'
export const CATEGORY = 'Category'
